var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon32PxShoppingBag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8625 25.9177C26.8916 26.1758 26.8654 26.4371 26.7861 26.6846C26.7068 26.9319 26.5762 27.1598 26.4025 27.353C26.2284 27.5458 26.0153 27.6998 25.7776 27.8044C25.5396 27.9091 25.2822 27.9622 25.0224 27.9602H7.06257C6.80268 27.9622 6.54534 27.9091 6.30746 27.8044C6.06959 27.6998 5.85657 27.5458 5.68246 27.353C5.5088 27.1598 5.37804 26.9319 5.29875 26.6846C5.21946 26.4371 5.19344 26.1758 5.22242 25.9177L6.84175 11.3989H25.2432L26.8625 25.9177Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4414 11.4006V8.6404C11.4414 7.42031 11.9261 6.25018 12.7888 5.38745C13.6515 4.52472 14.8217 4.04004 16.0418 4.04004C17.2619 4.04004 18.432 4.52472 19.2947 5.38745C20.1575 6.25018 20.6421 7.42031 20.6421 8.6404V11.4006",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32PxShoppingBag);
export default __webpack_public_path__ + "static/media/icon_32px_shopping-bag.11734f1f5fbde48c0a05f5aa932a9d14.svg";
export { ForwardRef as ReactComponent };